import styled from '@emotion/styled';
import Typography from '@mui/material/Typography';
import BodyWidgetMenu from './graph/BodyWidgetMenu';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionSummary from '@mui/material/AccordionSummary';
import { CanvasWidget } from '@projectstorm/react-canvas-core';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Badge, DialogContentText, useTheme } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Accordion from '@mui/material/Accordion';
import { TrayWidget } from './TrayWidget';
import RawMetricProperties from 'features/rawMetric/rawMetric-properties';
import MediaProperties from 'features/media/media-properties';
import PlayerProperties from 'features/player/player-properties';
import ContentHouseProperties from 'features/contentHouse/contentHouse-properties';
import { TrayItemWidget } from './TrayItemWidget';
import { DemoCanvasWidget } from './graph/DemoCanvasWidget';
import { useEffect, useState } from 'react';
import { MetricsApplication } from './graph/MetricsApplication';
import { MetricsNodeModel, MetricsPorts } from './graph/MetricsNodeModel';
import { getHashColor } from './graph/metrics_util';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Browser, MetricStep, OperatingSystems, RawMetricKeys } from 'features/enumerations';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { DataGrid } from '@mui/x-data-grid';
import { queryGraph } from './graph/util';
import {
    Button, ButtonGroup, Checkbox, FormControl, FormGroup,
    InputLabel, MenuItem, Select, Stack, TextField, CircularProgress,
    Stepper, Step, StepLabel, Grid, Box
} from '@mui/material';
import { useNavigate } from "react-router-dom";
import { MetricConfiguration, MetricCursor, MetricDeployment, MetricDeploymentConfig, TagMetaProperties } from 'models';
import PopupDialog from './PopupDialog';
import { decipherDate } from 'features/shared_components';
const raw_metric_properties = RawMetricProperties;
export default function MetricConfigurationComponent(props: {
    onSaveMetricConfiguration: (metricConfiguration: any) => void,
    onSaveDeployment: (config: MetricDeploymentConfig) => void,
    menuItem: { handler: () => void, name: string }[],
    onToggleMetricDeployment: (id: string) => void,
    onUnselectConfiguration: () => void,
    onDelete: (id: string) => void,
    onResetCursors: () => void,
    onDeleteDeployment: (id) => void,
    metricConfiguration: MetricConfiguration,
    metricConfigurations: MetricConfiguration[],
    metricDeployment: MetricDeployment,
    cursors: MetricCursor[],
    metricDeployments: MetricDeployment[],
    onSelect: (id: string) => void,
    onDeploymentSelect: (id: string) => void
}) {
    let accordion_style = { maxHeight: 400, overflowY: 'auto', overflowX: 'hidden' };
    const [application, setApplication] = useState(null);
    const [state, setState] = useState<any>({})
    const [name, setName] = useState('');
    const [cursorOpen, setCursorOpen] = useState(false);
    const theme = useTheme();
    const [startState, setStartSave] = useState(0);
    const navigate = useNavigate();
    useEffect(() => {
        let metricApplication = new MetricsApplication();
        setApplication(metricApplication);
        const handler = async (e) => {
            if ((window.navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey) && e.keyCode == 83) {
                e.preventDefault();
                setStartSave(Date.now());
            }
        }
        document.addEventListener("keydown", handler, false);
        return () => {
            document.removeEventListener('keydown', handler);
        }
    }, []);
    useEffect(() => {
        parseQuery();
        save();
    }, [startState]);

    useEffect(() => {

    }, [props.metricConfiguration])
    function parseQuery() {
        if (application) {
            let model = application.getDiagramEngine().getModel();
            let nodes = model.getNodes() as MetricsNodeModel[];
            let metricConfig = nodes.find(x => x.isRawMetricConfig());
            if (metricConfig) {
                let rawMetric = queryGraph(metricConfig, `${MetricsPorts.Select} >|${MetricsPorts.RawMetric}`) as MetricsNodeModel;
                let addFunction = queryGraph(metricConfig, `${MetricsPorts.Function} >${MetricsPorts.Add}|`);
                let hashFunction = queryGraph(metricConfig, `${MetricsPorts.Function} >${MetricsPorts.HashAdd}|`);
                let keyName = Object.values(RawMetricKeys).find((key: string) => {
                    return queryGraph(metricConfig, `${MetricsPorts.MetricKeys} >${key}|`)
                });
                console.log(rawMetric);
                if (rawMetric) {
                    let properties = raw_metric_properties.filter(({ name }) => {
                        return queryGraph(rawMetric, `${name} >|`);
                    }).map(({ name }) => {
                        let operation = queryGraph(rawMetric, `${name} >|`);
                        if (operation) {
                            let target = queryGraph(operation, `B >|`);
                            let targetPort = queryGraph(operation, `B>id| id`);
                            if (target && targetPort) {
                                return {
                                    operation: operation.getName(),
                                    target: target.getName(),
                                    targetPort: targetPort.getName()
                                }
                            }
                        }
                    }).filter(x => x);
                    console.log(properties);
                    let method = '';
                    if (addFunction) {
                        method = addFunction.getName() || MetricsPorts.Add;
                    }
                    else {
                        method = hashFunction.getName() || MetricsPorts.HashAdd;
                    }
                    if (method && properties && keyName)
                        return {
                            method,
                            properties,
                            keyName
                        } as MetricDeploymentConfig
                }
            }
        }
        return null;
    }
    function save() {
        if (props.onSaveMetricConfiguration && application && name) {
            let model = application.getDiagramEngine().getModel().serialize();
            let model_ = application.getDiagramEngine().getModel();
            let nodes = model_.getNodes() as MetricsNodeModel[];
            if (nodes.length) {
                props.onSaveMetricConfiguration({
                    ...(props.metricConfiguration || {}),
                    name,
                    graph: JSON.stringify(model)
                })
            }
        }
    }
    function generateInterfaceItemWidgets() {
        return [(
            <TrayItemWidget
                key={'RawMetricConfig'}
                model={{ type: 'RawMetricConfig', color: getHashColor('RawMetricConfig'), properties: [] }}
                name={'Raw Metric Configuration'} color={getHashColor('RawMetricConfig')} />
        ), (
            <TrayItemWidget
                key={'raw-metric-properties'}
                model={{ type: 'RawMetricProperties', color: 'rgb(0,12,235)', properties: raw_metric_properties }}
                name={'Raw Metric Properties'} color={getHashColor('RawMetricProperties')} />
        ), (
            <TrayItemWidget
                key={'MediaProperties'}
                model={{
                    name: 'Media',
                    type: 'ClassProperties',
                    color: getHashColor('MediaProperties'),
                    properties: MediaProperties.filter(x => x.name === 'id')
                }}
                name={'Media Properties'} color={getHashColor('MediaProperties')} />
        ), (
            <TrayItemWidget
                key={'PlayerProperties'}
                model={{
                    name: 'Player',
                    type: 'ClassProperties',
                    color: getHashColor('PlayerProperties'),
                    properties: PlayerProperties.filter(x => x.name === 'id')
                }}
                name={'Player Properties'} color={getHashColor('PlayerProperties')} />
        ), (
            <TrayItemWidget
                key={'ContentHouseProperties'}
                model={{
                    name: 'Content House',
                    type: 'ClassProperties', color: getHashColor('ContentHouseProperties'), properties: ContentHouseProperties.filter(x => x.name === 'id')
                }}
                name={'Content House Properties'} color={getHashColor('ContentHouseProperties')} />
        ), (
            <TrayItemWidget
                key={'AddFunction'}
                model={{ type: 'AddFunction', color: getHashColor('AddFunction'), properties: [] }}
                name={'Add Function'} color={getHashColor('AddFunction')} />
        ), (
            <TrayItemWidget
                key={'HashAddFunction'}
                model={{ type: 'HashAddFunction', color: getHashColor('HashAddFunction'), properties: [] }}
                name={'Hash Add Function'} color={getHashColor('HashAddFunction')} />
        ), (
            <TrayItemWidget
                key={'NumberValue10'}
                model={{
                    type: 'NumberValue', color: getHashColor('10'), properties: [{
                        name: '10',
                        defaultName: '10',
                        type: 'NUMBER'
                    }]
                }}
                name={'10'} color={getHashColor('10')} />
        ), (
            <TrayItemWidget
                key={'NumberValue100'}
                model={{
                    type: 'NumberValue', color: getHashColor('100'), properties: [{
                        name: '100',
                        defaultName: '100',
                        type: 'NUMBER'
                    }]
                }}
                name={'100'} color={getHashColor('100')} />
        ),
        <TrayItemWidget
            key={'equal-operation'}
            model={{
                type: 'EqualOperation', color: getHashColor('EqualOperation'), properties: [{
                    name: 'Equal', defaultName: 'Equal', 'type': ''
                }]
            }}
            name={'Equal'} color={getHashColor('EqualOperation')} />,
        <TrayItemWidget
            key={'oneof-operation'}
            model={{
                type: 'OneOfOperation', color: getHashColor('OneOfOperation'), properties: [{
                    name: 'One Of', defaultName: 'Equal', 'type': ''
                }]
            }}
            name={'One of'} color={getHashColor('OneOfOperation')} />,
        <TrayItemWidget
            key={'browsers'}
            model={{
                type: 'Browser', color: getHashColor('Browser'), properties: Object.entries(Browser).map(t => {
                    return ({
                        name: t[0],
                        defaultName: t[0],
                        type: 'Browser'
                    })
                })
            }}
            name={'Browsers'} />,
        <TrayItemWidget
            key={'OperatingSystem'}
            model={{
                type: 'OperatingSystem', color: getHashColor('OperatingSystem'), properties: Object.entries(OperatingSystems).map(t => {
                    return ({
                        name: t[0],
                        defaultName: t[0],
                        type: 'OperatingSystem'
                    })
                })
            }}
            name={'Operating Systems'} />,
        <TrayItemWidget
            key={'RawMetricKeys'}
            model={{
                type: 'StringEnumeration',
                color: getHashColor('RawMetricKeys'),
                properties: Object.entries(RawMetricKeys).map(t => {
                    return ({
                        name: t[0],
                        defaultName: t[0],
                        type: 'RawMetricKeys'
                    })
                })
            }}
            name={'Raw Metric Keys'} />];
    }
    function getStepCategoryCount(step: MetricStep): number {
        switch (step) {
            case MetricStep.Minute:
                return 60;
            case MetricStep.TenMinutes:
                return 60;
            case MetricStep.ThirtyMinutes:
                return 60;
            case MetricStep.Hour:
                return 24;
            case MetricStep.Day:
                return 24;
            case MetricStep.Week:
                return 24;
            case MetricStep.FourWeek:
                return 24;

        }
        return 10;
    }
    function getEndDate(startTime: number, step: MetricStep): number {
        let addAmount = 0;
        switch (step) {
            case MetricStep.Minute:
                addAmount = 60 * 1000;
                break;
            case MetricStep.TenMinutes:
                addAmount = 10 * 60 * 1000;
                break;
            case MetricStep.ThirtyMinutes:
                addAmount = 30 * 60 * 1000;
                break;
            case MetricStep.Hour:
                addAmount = 60 * 60 * 1000;
                break;
            case MetricStep.Day:
                addAmount = 24 * 60 * 60 * 1000;
                break;
            case MetricStep.Week:
                addAmount = 7 * 24 * 60 * 60 * 1000;
                break;
            case MetricStep.FourWeek:
                addAmount = 4 * 7 * 24 * 60 * 60 * 1000;
                break;

        }
        return startTime + addAmount;
    }
    function buildNode(args: any) {
        let new_node = new MetricsNodeModel({
            properties: args
        });
        return new_node;
    }
    return <>
        <S.Body>
            <S.Header>
                <Button type="button" key={'buton'} onClick={() => {
                    navigate(-1);
                }} className="btn btn-tool" data-card-widget="collapse">

                    <ArrowBackIosIcon />
                </Button>
                <BodyWidgetMenu menuTitle={`${name || ''}`.trim() || 'Menu'} menuItems={[{
                    title: 'New',
                    handler: () => {
                        application.newModel();
                        setName('');
                        if (props.onUnselectConfiguration) {
                            props.onUnselectConfiguration()
                        }
                    }
                }, {
                    handler: async () => {
                        save();
                    },
                    title: 'Save'
                }, {
                    handler: async () => {
                        if (props.onDelete && props?.metricConfiguration?.id) {
                            props.onDelete(props?.metricConfiguration?.id);
                            if (props.onUnselectConfiguration) {
                                props.onUnselectConfiguration()
                                setName('');
                                application.newModel();
                            }
                        }
                    },
                    title: 'Delete'
                }]} />
                <BodyWidgetMenu menuTitle={'Deployment'} menuItems={[{
                    title: 'Add',
                    handler: () => {
                        let deploymentConfig = parseQuery();
                        if (props.onSaveDeployment) {
                            props.onSaveDeployment(deploymentConfig);
                        }
                    }
                }, !props?.metricDeployment ? null : {
                    title: props?.metricDeployment?.enabled ? 'Disabled' : 'Enable',
                    handler: () => {
                        if (props.onToggleMetricDeployment) {
                            props.onToggleMetricDeployment(props?.metricDeployment?.id);
                        }
                    }
                }, !props?.metricDeployment?.id ? null : {
                    title: 'Delete Deployment',
                    handler: () => {
                        props.onDeleteDeployment(props?.metricDeployment?.id);
                    }
                }, {
                    title: 'Reset Cursors',
                    handler: () => {
                        props.onResetCursors();
                    }
                }].filter(x => x)} />
                <BodyWidgetMenu menuTitle={'Run Time'} menuItems={(props.menuItem || []).map(v => {
                    return {
                        ...v,
                        title: v.name
                    }
                }).filter(x => x)} />
                <Button type="button" key={'buton'} onClick={() => {
                    setCursorOpen(true);
                }} className="btn btn-tool" data-card-widget="collapse">
                    Cursors
                </Button>
            </S.Header>
            <S.Content>
                <TrayWidget>
                    <FormGroup>
                        <TextField
                            margin="dense"
                            fullWidth
                            variant="standard"
                            onChange={(evt) => {
                                setName(evt.currentTarget.value);
                            }}
                            value={name} />
                    </FormGroup>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography>Raw Metrics Blocks</Typography>
                        </AccordionSummary>
                        <AccordionDetails style={{ ...accordion_style }}>
                            <div>
                                {generateInterfaceItemWidgets()}
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography>Deployments</Typography>
                        </AccordionSummary>
                        <AccordionDetails style={{ ...accordion_style }}>
                            <List>
                                {props.metricDeployments?.filter(x => {
                                    return x.metricConfigurationId === props.metricConfiguration?.id;
                                }).map((item) => {
                                    let statusColor = item?.id === props?.metricDeployment?.id ? theme.palette.success.main : theme.palette.info.main;
                                    let enabledColor = item?.enabled ? theme.palette.primary.main : theme.palette.error.main;
                                    return (

                                        <ListItemButton key={item?.id}
                                            selected={item?.id === props?.metricDeployment?.id}
                                            onClick={() => {
                                                if (props.onDeploymentSelect) {
                                                    props.onDeploymentSelect(item?.id)
                                                }
                                            }}>
                                            <Grid item xs={12}>
                                                <Grid container spacing={2}>
                                                    <Grid item>
                                                        <Box sx={{ position: 'relative' }}>
                                                            <Badge
                                                                overlap="circular"
                                                                badgeContent={
                                                                    <FiberManualRecordIcon sx={{
                                                                        color: enabledColor,
                                                                        fontSize: '0.875rem'
                                                                    }} />
                                                                }
                                                                anchorOrigin={{
                                                                    vertical: 'bottom',
                                                                    horizontal: 'right'
                                                                }}
                                                            >
                                                            </Badge>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs zeroMinWidth>
                                                        <Typography align="left" component="div" variant="subtitle1">
                                                            {item?.name}
                                                        </Typography>
                                                        <Typography align="left" component="div" style={{
                                                            whiteSpace: 'nowrap',
                                                            maxWidth: 200,
                                                            textOverflow: 'ellipsis',
                                                            overflow: 'hidden'
                                                        }} variant="subtitle2">
                                                            {item?.player?.firstName} {item?.player?.lastName}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </ListItemButton>
                                    )
                                })}
                            </List>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography>Configurations</Typography>
                        </AccordionSummary>
                        <AccordionDetails style={{ ...accordion_style }}>
                            <div>
                                {(props.metricConfigurations || []).map((configuration, i: number) => {
                                    return (
                                        <ListItem key={`asdf-${i}`} disablePadding>
                                            <ListItemButton onClick={() => {
                                                if (application && configuration?.graph) {
                                                    application.deserialize(configuration.graph);
                                                    props.onSelect(configuration.id)
                                                    setName(configuration.name);
                                                }
                                            }}>
                                                <ListItemIcon>
                                                    <AccountTreeIcon color={props?.metricConfiguration?.id === configuration.id ? 'success' : 'secondary'} />
                                                </ListItemIcon>
                                                <ListItemText primary={configuration?.name} />
                                            </ListItemButton>
                                        </ListItem>
                                    )
                                })}
                            </div>
                        </AccordionDetails>
                    </Accordion>
                </TrayWidget>
                {application && <S.Layer
                    onDrop={async (event) => {
                        if (application) {
                            var data = JSON.parse(event.dataTransfer.getData('storm-diagram-node'));
                            let point = application.getDiagramEngine().getRelativeMousePoint(event);
                            let new_node: MetricsNodeModel | null = null;
                            switch (data.type) {
                                default:
                                    new_node = buildNode(data);
                                    if (new_node) {
                                        new_node.setPosition(point);
                                        let engine = application?.getDiagramEngine();
                                        engine.getModel().addNode(new_node);
                                    }
                                    break;
                            }
                        }

                    }}
                    onDragOver={(event) => {
                        event.preventDefault();
                    }}>
                    <DemoCanvasWidget>
                        <CanvasWidget engine={application?.getDiagramEngine()} />
                    </DemoCanvasWidget>

                </S.Layer>}
            </S.Content>
        </S.Body>

        <PopupDialog onClose={() => {
            setCursorOpen(false);
        }} title="Cursors" open={cursorOpen} >
            <DialogContentText>
                Cursors
            </DialogContentText>
            <div style={{ height: `80vh` }}>
                <DataGrid
                    rows={props.cursors || []}
                    columns={[
                        {
                            width: 150, field: 'id', headerName: 'ID'
                        },
                        {
                            field: 'keyName',
                            width: 250,
                            headerName: 'Key Name'
                        },
                        {
                            field: 'owner',
                            width: 150,
                            headerName: 'Owner'
                        },
                        { field: 'step', headerName: 'Step' },
                        { field: 'index', headerName: 'Index' },
                        { field: 'inception', headerName: 'Inception' },
                        {
                            width: 750,
                            field: 'time',
                            headerName: 'Time => End Time',
                            type: 'number',
                            valueGetter: (params) => `${decipherDate(params.row.time)} -> ${decipherDate(getEndDate(params.row.time, params.row.step))}`
                        },
                        {
                            field: 'version',
                            headerName: 'Version',
                            description: 'Version'
                        },
                    ]}
                    pageSize={50}
                    rowsPerPageOptions={[5]}
                />
            </div>
        </PopupDialog>
    </>;
}

namespace S {
    export const Body = styled.div`
		flex-grow: 1;
		display: flex;
		flex-direction: column;
		min-height: 100%;
        height: 100vh;
	`;

    export const Header = styled.div`
		display: flex;
		background: rgb(30, 30, 30);
		flex-grow: 0;
		flex-shrink: 0;
		color: white;
		font-family: Helvetica, Arial, sans-serif;
		padding: 10px;
		align-items: center;
	`;

    export const Content = styled.div`
		display: flex;
		flex-grow: 1;
	`;

    export const Layer = styled.div`
		position: relative;
		flex-grow: 1;
	`;
}


